// File: src/components/pages/Homepage-Minimal.jsx
// Ultra-clean minimal design - NO LIGHTBOX, NO MODAL ISSUES

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, UserPlus } from 'lucide-react';
import './Homepage-Minimal.css';

// Import images (adjust paths as needed)
import logo from '../../assets/logo14.png';
import studentBooking from '../../assets/StudentSlotBooking.png';
import myBookings from '../../assets/Student-MyBookings.png';
import manageStudents from '../../assets/ManageStudents-ActiveStudents.png';
import manageSlots from '../../assets/ManageBookings-MySlots.png';
import manageTemplate from '../../assets/ManageTemplate.png';
import studentSignup from '../../assets/Student-Signup.png';
import LoginButton from '../../components/LoginButton';

const HomepageMinimal = () => {
  const navigate = useNavigate();

  const features = [
    { image: manageTemplate, title: 'Templates', description: 'Schedule templates' },
    { image: manageSlots, title: 'View Schedule', description: 'Manage your calendar' },
    { image: manageStudents, title: 'Manage Students', description: 'Track student progress' },
    { image: studentBooking, title: 'Book Slots', description: 'Quick and easy booking' },
    { image: myBookings, title: 'My Bookings', description: 'View upcoming lessons' },
    { image: studentSignup, title: 'Registration', description: 'Easy student signup' }
  ];

  return (
    <div className="minimal-homepage">
      {/* Auth Links - Top Right */}
      <div className="auth-links">
        <LoginButton className="link-btn" />
        <button className="link-btn signup" onClick={() => navigate('/explore')}>
          <UserPlus size={16} />
          <span>Sign Up</span>
        </button>
      </div>

      {/* Main Content - Centered */}
      <div className="content-center">
        {/* Logo */}
        <div className="logo-wrapper">
          <img src={logo} alt="Booking System" className="logo-img" />
        </div>

        {/* Title */}
        <h1 className="main-title">Booking System</h1>
        <p className="subtitle">Simple. Efficient. Professional.</p>

        {/* Feature Grid */}
        <div className="feature-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="card-image-wrapper">
                <img src={feature.image} alt={feature.title} />
              </div>
              <div className="card-content">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Quick Actions */}
        <div className="quick-actions">
          <button className="link-btn signup" onClick={() =>  navigate('/explore')}>
            Get Started
          </button>
          <LoginButton className="link-btn" />
        </div>
      </div>
    </div>
  );
};

export default HomepageMinimal;